import React from 'react'
import EventsPage from "../Components/events/eventspage";

function eventspage() {
    return (
        <EventsPage />
      )
}

export default eventspage
